export default class Tabs {
  constructor() {
    this.tabsContainers = $('.tabbed-table-container');
    this.tabsContainers.each(function() {
      $(this)
        .find('ul.tabbed-panel')
        .removeClass('active')
        .eq(0)
        .addClass('active');
    });
  }

  listenEvents() {
    this.tabsContainers.on('click', 'ul.tabbed-panel', function() {
      const tab = $(this);

      tab
        .parents()
        .eq(2)
        .find('ul.tabbed-panel')
        .removeClass('active');
      tab.addClass('active');
    });
  }

  stopListening() {
    this.tabsContainers.off('click');
  }
}
